import { User, userContext } from "@/context/UserContext";
import { getUserProfile } from "@/services/authService";
import { useContext } from "react";

const useUser = () => {
  const context = useContext(userContext);
  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }
  const { user, setUser } = context;

  const loadUserData = async (token: string) => {
    try {
      if (token) {
        const user = await getUserProfile(token);
        setUser(user);
      }
    } catch (error) {
      console.error("Error loading user data:", error);
    }
  };

  const addPoints = async (points: number) => {
    setUser(
      (prevUser) =>
        ({
          ...prevUser,
          points: (prevUser?.points ?? 0) + points,
        } as User)
    );
  };

  return { user, setUser, loadUserData, addPoints };
};

export default useUser;
